import { z } from 'zod'

export const WORK_TASK_TRACKER_ISSUE_FILTER_CONTRACT_VERSION = '1.0.0' as const
export const workTaskTrackerIssueFilterResponseSchema = z.unknown()
export type WorkTaskTrackerIssueFilterResponse = z.infer<typeof workTaskTrackerIssueFilterResponseSchema>
